import { lazy } from "react";
import { PERMISSIONS } from "constants/permissions";
import { createBrowserRouter } from "react-router-dom";

const Login = lazy(() => import("pages/login"));
const NotFound = lazy(() => import("pages/notfound"));
const PrivateRouter = lazy(() => import("routers/private"));

const RouterReserveProvince = lazy(
  () => import("pages/reserve/province/router")
);
const RouterReserveRegion = lazy(() => import("pages/reserve/region/router"));
const RouterReserveRepublic = lazy(
  () => import("pages/reserve/republic/router")
);

export const router = createBrowserRouter([
  {
    path: "",
    element: <Login />,
  },
  {
    path: "admin",
    element: <PrivateRouter />,
    children: [
      {
        path: `${PERMISSIONS.PROVINCE}/*`,
        element: <RouterReserveProvince />,
      },
      {
        path: `${PERMISSIONS.REGION}/*`,
        element: <RouterReserveRegion />,
      },
      {
        path: `${PERMISSIONS.REPUBLIC}/*`,
        element: <RouterReserveRepublic />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound variant="auth" />,
  },
]);
